<template>
    <div id="wrapper" :class="langCss">
            <!-- start header -->
            <header>
                <div class="navbar navbar-default navbar-static-top">
                    <div class="container">
                        <div class="navbar-header">
                            <button type="button" class="navbar-toggle" data-toggle="collapse"
                                data-target=".navbar-collapse">
                                <span class="icon-bar"></span>
                                <span class="icon-bar"></span>
                                <span class="icon-bar"></span>
                            </button>
                            <router-link to="/" class="navbar-brand"><img src="/static/img/logo.png" alt="logo" /></router-link>
                        </div>
                        <div class="navbar-collapse collapse ">
                            <ul class="nav navbar-nav">
                                <li class="active"><router-link to="/" class="navbar-item">{{ $t('message.home') }}</router-link></li>
                                <li><router-link to="/services" class="navbar-item">{{ $t('message.serve') }}</router-link></li>
                                <!-- <li v-if="langCss != 'cn'"><a href="http://www.cflytrip.com" class="navbar-item" style="color:coral" >{{ $t('message.book') }}</a></li> -->
                                <li><router-link to="/portf" class="navbar-item">{{ $t('message.port') }}</router-link></li>
                                <!-- <li><router-link to="/aboutus" class="navbar-item">{{ $t('message.au') }}</router-link></li> -->
                                <li><router-link to="/pricing" class="navbar-item">{{ $t('message.pric') }}</router-link></li>
                                <li><router-link to="/contact" class="navbar-item">{{ $t('message.contact') }}</router-link></li>
                            </ul>
                        </div>
                        <div class="ceswich">
                            <button style="background:none;border:none" :class="langCss === 'cn' ? 'xz' : ''"
                                @click="switchLang('cn')">{{ $t('message.switchCn') }}</button> |
                            <button style="background:none;border:none" :class="langCss === 'en' ? 'xz' : ''"
                                @click="switchLang('en')">{{ $t('message.switchEn') }}</button>
                        </div>
                    </div>
                </div>
            </header>
                <section id="featured">
                <!-- Slider -->
                <div id="main-slider" class="flexslider">
                    <ul class="slides">
                        <li>
                            <img src="/static/img/slides/1.jpg" alt="" />
                            <div class="flex-caption">
                                <h3> {{ $t('message.slider') }}</h3>
                                <p > {{ $t('message.sliderCn') }}</p>
                            </div>
                        </li>
                        <li>
                            <img src="/static/img/slides/2.jpg" alt="" />
                            <div class="flex-caption">
                                <h3> {{ $t('message.slider2') }}</h3>
                                <p> {{ $t('message.sliderCn2') }}</p>
                            </div>
                        </li>
                        <li>
                            <img src="/static/img/slides/3.jpg" alt="" />
                            <div class="flex-caption">
                                <h3> {{ $t('message.slider3') }}</h3>
                                <p> {{ $t('message.sliderCn3') }}</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- end slider -->
            </section>
            <div class="content_white">
                <h2>{{ $t('message.welcomeMsg') }}</h2>
                <p class="mycompaly">{{ $t('message.myCompany') }}</p>
                <p class="mycompaly">{{ $t('message.myCompany2') }}</p>
            </div>
            <div class="featured_content">
                <div class="container">
                    <div class="row text-center">
                        <div class="col-md-3 feature_grid1">
                            <i class="fa fa-2013"></i>
                            <h3><a href="#">{{ $t('message.milepost') }}</a></h3>
                            <p>{{ $t('message.milepostCon') }}</p>
                            <!-- <a href="#" class="feature_btn">More</a> -->
                        </div>
                        <div class="col-md-3 feature_grid1">
                            <i class="fa fa-2015"></i>
                            <h3><a href="#">{{ $t('message.milepost2') }}</a></h3>
                            <p>{{ $t('message.milepostCon2') }}</p>
                            <!-- <a href="#" class="feature_btn">More</a> -->
                        </div>
                        <div class="col-md-3 feature_grid1">
                            <i class="fa fa-2018"></i>
                            <h3><a href="#">{{ $t('message.milepost3') }}</a></h3>
                            <p>{{ $t('message.milepostCon3') }}</p>
                            <!-- <a href="#" class="feature_btn">More</a> -->
                        </div>
                        <div class="col-md-3 feature_grid1">
                            <i class="fa fa-2024"></i>
                            <h3><a href="#">{{ $t('message.milepost4') }}</a></h3>
                            <p>{{ $t('message.milepostCon4') }}</p>
                            <!-- <a href="#" class="feature_btn">More</a> -->
                        </div>
                    </div>
                </div>
            </div>

            <section id="content">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8">
                            <!-- Heading and para -->
                            <div class="block-heading-two">
                                <h3><span>{{ $t('message.whyUS') }} </span></h3>
                            </div>
                            <p class="whyUscont">{{ $t('message.whyUscont') }}</p>
                            <p class="whyUscont">{{ $t('message.whyUscont2') }}</p>
                        </div>
                        <div class="col-md-4">
                            <div class="block-heading-two">
                                <h3><span>{{ $t('message.Solution') }}</span></h3>
                            </div>
                            <!-- Accordion starts -->
                            <div class="panel-group" id="accordion-alt3">
                                <!-- Panel. Use "panel-XXX" class for different colors. Replace "XXX" with color. -->
                                <div class="panel">
                                    <!-- Panel heading -->
                                    <div class="panel-heading">
                                        <h4 class="panel-title">
                                            <a data-toggle="collapse" data-parent="#accordion-alt3" href="#collapseOne-alt3">
                                                <i class="fa fa-angle-right"></i> {{ $t('message.SolutionTit') }}
                                            </a>
                                        </h4>
                                    </div>
                                    <div id="collapseOne-alt3" class="panel-collapse collapse">
                                        <!-- Panel body -->
                                        <div class="panel-body">{{ $t('message.SolutionCon') }}</div>
                                    </div>
                                </div>
                                <div class="panel">
                                    <div class="panel-heading">
                                        <h4 class="panel-title">
                                            <a data-toggle="collapse" data-parent="#accordion-alt3" href="#collapseTwo-alt3">
                                                <i class="fa fa-angle-right"></i> {{ $t('message.SolutionTit2') }}
                                            </a>
                                        </h4>
                                    </div>
                                    <div id="collapseTwo-alt3" class="panel-collapse collapse">
                                        <div class="panel-body">{{ $t('message.SolutionCon2') }}</div>
                                    </div>
                                </div>
                                <div class="panel">
                                    <div class="panel-heading">
                                        <h4 class="panel-title">
                                            <a data-toggle="collapse" data-parent="#accordion-alt3" href="#collapseThree-alt3">
                                                <i class="fa fa-angle-right"></i>  {{ $t('message.SolutionTit3') }}
                                            </a>
                                        </h4>
                                    </div>
                                    <div id="collapseThree-alt3" class="panel-collapse collapse">
                                        <div class="panel-body">{{ $t('message.SolutionCon3') }}</div>
                                    </div>
                                </div>
                                <div class="panel">
                                    <div class="panel-heading">
                                        <h4 class="panel-title">
                                            <a data-toggle="collapse" data-parent="#accordion-alt3" href="#collapseFour-alt3">
                                                <i class="fa fa-angle-right"></i> {{ $t('message.SolutionTit4') }}
                                            </a>
                                        </h4>
                                    </div>
                                    <div id="collapseFour-alt3" class="panel-collapse collapse">
                                        <div class="panel-body">{{ $t('message.SolutionCon4') }}</div>
                                    </div>
                                </div>
                            </div>
                            <!-- Accordion ends -->
                        </div>
                    </div>
                </div>
            </section>
            <section id="content">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <!-- Heading and para -->
                            <div class="block-heading-two">
                                <h3><span>{{$t('message.domestic')}}</span></h3>
                            </div>
                            <h3 style="text-align: center;">{{$t('message.domesticOta')}}</h3>
                            <div class="block-img">
                                <img v-if="langCss === 'cn'" src="/static/img/OTAPT.png" alt="" />
                                <img v-else src="/static/img/GJOTAPT.png" alt="" />
                            </div>
                            <h3 style="text-align: center;">{{$t('message.domesticAir')}}</h3>
                            <div class="block-img">
                                <img v-if="langCss === 'cn'" src="/static/img/GNHSHJ.png" alt="" />
                                <img v-else src="/static/img/GJHSHJ.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div class="testimonial-area">
                <div class="testimonial-solid">
                    <div class="container">
                        <div id="carousel-example-generic" class="carousel slide" data-ride="carousel">
                            <ol class="carousel-indicators">
                                <li data-target="#carousel-example-generic" data-slide-to="0" class="">
                                    <a href="#"></a>
                                </li>
                                <li data-target="#carousel-example-generic" data-slide-to="1" class="">
                                    <a href="#"></a>
                                </li>
                                <li data-target="#carousel-example-generic" data-slide-to="2" class="active">
                                    <a href="#"></a>
                                </li>
                                <li data-target="#carousel-example-generic" data-slide-to="3" class="">
                                    <a href="#"></a>
                                </li>
                            </ol>
                            <div class="carousel-inner">
                                <div class="item">
                                    <p>{{$t('message.gsquotcont')}}</p>
                                    <p><b>- {{$t('message.gsquot')}} -</b></p>
                                </div>
                                <div class="item">
                                    <p>{{$t('message.gsquotcont2')}}</p>
                                    <p><b>- {{$t('message.gsquot2')}} -</b></p>
                                </div>
                                <div class="item active">
                                    <p>{{$t('message.gsquotcont3')}}</p>
                                    <p><b>- {{$t('message.gsquot3')}} -</b></p>
                                </div>
                                <div class="item">
                                    <p>{{$t('message.gsquotcont4')}}</p>
                                    <p><b>- {{$t('message.gsquot4')}} -</b></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <footer>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="widget">
                                <address style="width:60%;float: left;">
                                    <strong>{{$t('message.addr')}}</strong><br>
                                    {{$t('message.addrcon')}}
                                </address>
                                <p style="margin-left:5%;width:30%;float: left;">
                                    <strong>{{$t('message.widgetCn')}}</strong><br>
                                    <i class="icon-phone"></i> {{$t('message.fixedTelephone')}} <br>
                                    <i class="icon-envelope-alt"></i> leo@cflytrip.com
                                </p>
                            </div>
                        </div>
                        <!-- <div class="col-lg-3">
                            <div class="widget">
                                <h5 class="widgetheading"> {{$t('message.domestic')}} </h5>
                                <ul class="link-list">
                                    <li><a href="https://www.airchina.com.cn/" target="_blank">{{$t('message.flinkCon')}}</a></li>
                                    <li><a href="https://www.ceair.com/" target="_blank">{{$t('message.flinkCon2')}}</a></li>
                                    <li><a href="https://www.csair.com/" target="_blank">{{$t('message.flinkCon3')}}</a></li>
                                    <li><a href="https://www.hnair.com/" target="_blank">{{$t('message.flinkCon4')}}</a></li>
                                    <li><a href="https://www.cdal.com.cn" target="_blank">{{$t('message.flinkCon5')}}</a></li>
                                    <li><a href="https://www.loongair.cn" target="_blank">{{$t('message.flinkCon6')}}</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="widget">
                                <h5 class="widgetheading">{{$t('message.international')}}</h5>
                                <ul class="link-list">
                                    <li><a href="https://www.vietjet-air.com/" target="_blank">{{$t('message.flinkCon7')}}</a></li>
                                    <li><a href="https://www.koreanair.com/" target="_blank">{{$t('message.flinkCon8')}}</a></li>
                                    <li><a href="https://www.ana.co.jp/" target="_blank">{{$t('message.flinkCon9')}}</a></li>
                                    <li><a href="https://www.hkexpress.com/" target="_blank">{{$t('message.flinkCon10')}}</a></li>
                                    <li><a href="https://www.flyasiana.com/" target="_blank">{{$t('message.flinkCon11')}}</a></li>
                                    <li><a href="https://www.united.com/" target="_blank">{{$t('message.flinkCon12')}}</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="widget">
                                <h5 class="widgetheading">{{$t('message.platform')}}</h5>
                                <ul class="link-list">
                                    <li><a href="https://www.ctrip.com/" target="_blank">{{$t('message.flinkCon13')}}</a></li>
                                    <li><a href="https://www.qunar.com/" target="_blank">{{$t('message.flinkCon14')}}</a></li>
                                    <li><a href="https://www.ly.com/" target="_blank">{{$t('message.flinkCon15')}}</a></li>
                                    <li><a href="https://www.fliggy.com/" target="_blank">{{$t('message.flinkCon16')}}</a></li>
                                    <li><a href="https://www.meituan.com/" target="_blank">{{$t('message.flinkCon17')}}</a></li>
                                    <li><a href="https://buyer.pkfare.com/" target="_blank">{{$t('message.flinkCon18')}}</a></li>
                                </ul>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div id="sub-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="copyright">
                                    <p>
                                        <a href="https://beian.miit.gov.cn/" target="_blank">湘ICP备2020020380号-1</a>
                                        <span>&copy; Copyright ©2024 晨飞旅业 All Rights Reserved. </span>

                                    </p>
                                </div>
                            </div>
                            <div class="col-lg-6" style="position: relative;">
                              <a class="rztz" href="http://cx.cnca.cn/CertECloud/result/skipResultList?certNumber=05324I10341R0M%20%20%20&orgName=&fromIndex=true" target="_blank"><img class="ISO2007RZ" src="/static/img/rz2007.png" alt=""></a>
                                <!-- <ul class="social-network">
                                    <li>
                                        <a href="#" data-placement="top" title="Facebook"><i class="fa fa-facebook"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Twitter"><i class="fa fa-twitter"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Linkedin"><i class="fa fa-linkedin"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Pinterest"><i class="fa fa-pinterest"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Google plus"><i class="fa fa-google-plus"></i></a>
                                    </li>
                                </ul> -->
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
</template>

<script>
import { Image } from 'element-ui';

export default {
    name: "home",
    data() {
        return {
            langCss: window.localStorage.getItem("lang"),
            dialogVisible: false,
            currentUrl:''
        };
    },
    // created() {
    //     const path = window.location.hostname;
    //     const segments = path.substring(path.length-14,path.length);
    //     if (segments==='feixing001.com') {
    //         this.langCss = 'cn';
    //         window.localStorage.setItem('lang','cn');
    //     }else{
    //         this.langCss = 'en';
    //         window.localStorage.setItem('lang','en');
    //     }
    // },
    mounted(){
        $('#main-slider').flexslider({
            namespace           : "flex-",           //{NEW} String: Prefix string attached to the class of every element generated by the plugin
            selector            : ".slides > li",    //{NEW} Selector: Must match a simple pattern. '{container} > {slide}' -- Ignore pattern at your own peril
            animation           : "fade",            //String: Select your animation type, "fade" or "slide"
            easing              : "swing",           //{NEW} String: Determines the easing method used in jQuery transitions. jQuery easing plugin is supported!
            direction           : "horizontal",      //String: Select the sliding direction, "horizontal" or "vertical"
            reverse             : false,             //{NEW} Boolean: Reverse the animation direction
            animationLoop       : true,              //Boolean: Should the animation loop? If false, directionNav will received "disable" classes at either end
            smoothHeight        : false,             //{NEW} Boolean: Allow height of the slider to animate smoothly in horizontal mode
            startAt             : 0,                 //Integer: The slide that the slider should start on. Array notation (0 = first slide)
            slideshow           : true,              //Boolean: Animate slider automatically
            slideshowSpeed      : 7000,              //Integer: Set the speed of the slideshow cycling, in milliseconds
            animationSpeed      : 600,               //Integer: Set the speed of animations, in milliseconds
            initDelay           : 0,                 //{NEW} Integer: Set an initialization delay, in milliseconds
            randomize           : false,             //Boolean: Randomize slide order

            // Usability features
            pauseOnAction       : true,              //Boolean: Pause the slideshow when interacting with control elements, highly recommended.
            pauseOnHover        : false,             //Boolean: Pause the slideshow when hovering over slider, then resume when no longer hovering
            useCSS              : true,              //{NEW} Boolean: Slider will use CSS3 transitions if available
            touch               : true,              //{NEW} Boolean: Allow touch swipe navigation of the slider on touch-enabled devices
            video               : false,             //{NEW} Boolean: If using video in the slider, will prevent CSS3 3D Transforms to avoid graphical glitches

            // Primary Controls
            controlNav          : true,              //Boolean: Create navigation for paging control of each clide? Note: Leave true for manualControls usage
            directionNav        : true,              //Boolean: Create navigation for previous/next navigation? (true/false)
            prevText            : "Previous",        //String: Set the text for the "previous" directionNav item
            nextText            : "Next",            //String: Set the text for the "next" directionNav item

            // Secondary Navigation
            keyboard            : true,              //Boolean: Allow slider navigating via keyboard left/right keys
            multipleKeyboard    : false,             //{NEW} Boolean: Allow keyboard navigation to affect multiple sliders. Default behavior cuts out keyboard navigation with more than one slider present.
            mousewheel          : false,             //{UPDATED} Boolean: Requires jquery.mousewheel.js (https://github.com/brandonaaron/jquery-mousewheel) - Allows slider navigating via mousewheel
            pausePlay           : false,             //Boolean: Create pause/play dynamic element
            pauseText           : 'Pause',           //String: Set the text for the "pause" pausePlay item
            playText            : 'Play',            //String: Set the text for the "play" pausePlay item

            // Special properties
            controlsContainer   : "",                //{UPDATED} Selector: USE CLASS SELECTOR. Declare which container the navigation elements should be appended too. Default container is the FlexSlider element. Example use would be ".flexslider-container". Property is ignored if given element is not found.
            manualControls      : "",                //Selector: Declare custom control navigation. Examples would be ".flex-control-nav li" or "#tabs-nav li img", etc. The number of elements in your controlNav should match the number of slides/tabs.
            sync                : "",                //{NEW} Selector: Mirror the actions performed on this slider with another slider. Use with care.
            asNavFor            : "",                //{NEW} Selector: Internal property exposed for turning the slider into a thumbnail navigation for another slider
        });
    },
    methods: {
        switchLang(lang) {
            this.$i18n.locale = lang;
            //把语言保存在localStorage中
            localStorage.setItem("lang", lang);
            //切换父级class
            this.langCss = lang;
        },
        handleClose(done) {
            this.$confirm(this.$t("message.confirm")) //js内部切换
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vue-css button {
    width: 150px;
}

.en .vue-css button {
    color: steelblue;
}

.cn .vue-css button {
    color: #666;
}

.ja .vue-css button {
    color: seagreen;
}

.xz {
    color: #37A691
}
.mycompaly{
    max-width: 1000px;
    margin: 0 auto;
    text-align: left;
    text-indent: 20px;
    padding:0 20px;
    line-height: 30px;
}
.whyUscont{
    text-align: left;
    text-indent: 20px;
    line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue